export const common = {
  siteName: "USFansSpreadsheet",
  siteDescription: "Kompletny przewodnik, porównania i aktualizacje 2026",
  buyItNow: "Buy It Now",
  usfansSpreadsheet: "USFans Spreadsheet",
  viewGuide: "Zobacz poradnik",
  learnMore: "Dowiedz się więcej",
  checkFeatures: "Sprawdź funkcje",
  categories: "Kategorie",
  allCategories: "Wszystkie kategorie",
  home: "Start",
  guides: "Guides",
  tutorials: "Tutorials",
  reviews: "Reviews",
  articles: "Poradniki",
  shoppingGuide: "Poradnik zakupowy",
  readArticle: "Przeczytaj artykuł",
  backToHome: "← Powrót do strony głównej",
};